/**
 * @author 3173
 * @description 课程内容-添加课件
 * @Date 2020/2/13
 */
import React from "react";
import { connect } from "dva";
import { modelUtils, Storage, jsonToString } from "@/utils";
import { Spin } from "antd";
import { utils_tool, component_tool, framework_tool } from "@/tool";
const {
  WizCard,
  WizSearchBar,
  WizDataTable,
  WizListSelect,
  WizRow,
  WizCol
} = component_tool;
const { WizContainer } = framework_tool;
const { getPageData } = utils_tool;
import createColumns from "./stageListColumns";

class StageList extends WizContainer {
  componentName = "StageList";

  constructor(props) {
    super(props);
    this.state = {
      defaultSearch: true,
      apiParams: {},
      visible: false,
      record: null
    };
  }

  static defaultProps = {
    selectedRows: []
  }

  propsAndStateOnChange = {
    // existId: this._existIdOver.bind(this)
  };

  // _existIdOver(nextProps, nextState) {
  //   console.log(nextProps.existId,'nextProps.existId')
  //   if (nextProps.existId) {
  //     this._getData();
  //   }
  //   return true;
  // }

  _componentDidMount = () => {
    if (this.state.defaultSearch) {
      this._getData();
    }
  };

  _getData(other = {}) {
    const { existId } = this.props;
    this.doAction({
      path: "trainPathStage/stageListPage",
      payload: {
        key: "stageListPage",
        apiParams: { ...this.state.apiParams, ...other, state: 2, trainPathId: existId }
      }
    });
  }

  /**是否不可选，已被选择并展示再页面中的部分将不可选 */
  isNeedDisabled(id) {
    const { exists } = this.props;
    if (exists && exists.length > 0) {
      for (let i = 0; i < exists.length; i++) {
        if (exists[i].entityId === id && exists[i].type == 0) {
          return true;
          break;
        }
      }
    }
    return false;
  }

  onRow(record) {
    return {
      onClick: () => { }, // 点击行
      onDoubleClick: () => { },
      onContextMenu: () => { },
      onMouseEnter: () => { }, // 鼠标移入行
      onMouseLeave: () => { },
    };
  }

  _render() {
    const { stageListPage, scheduleManagementLoading, selectedRows, updateRows, handleClear,existId } = this.props;
    console.log(existId,'existId')
    const { record, visible } = this.state;
    console.log(stageListPage, 'stageListPage')

    const dataItems = getPageData(stageListPage.data);
    const other = {};
    console.log(dataItems, 'dataItems')
    const columns = createColumns(this, dataItems, other);
    console.log(columns, 'columns')
    const searchBarProps = {
      columns,
      collapse: false,
      onSearch: values =>
        this.setState({ apiParams: values }, () => {
          this._getData();
        })
    };

    const dataTableProps = {
      loading: scheduleManagementLoading,
      columns,
      rowKey: "id",
      dataItems,
      selectType: "radio",
      showNum: false,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this._getData({ current: pageNum, size: pageSize });
      },
      selectedRowKeys: selectedRows.map(item => item.rowKey),
      onSelect: (keys, rows) => {
        this.keys = keys;
        updateRows(rows)
      },
      rowSelection: {
        getCheckboxProps: record => ({
          disabled: this.isNeedDisabled(record.id),
        }),

      },
      //onRow:this.onRow.bind(this) ,
      //rowClassName:this.setClassName.bind(this)
    };

    const listSelectProps = {
      type: '课件',
      rows: selectedRows,
      handerClear: (id) => {
        handleClear(id)
      }
    }

    return (
      <WizRow>
        <WizCol span={24}>
          <WizCard bodyStyle={{ padding: '0 15px' }}>
            <WizSearchBar
              type="grid"
              {...searchBarProps}
              cols={{ xs: 14, md: 12, xl: 10 }}
            />
            <WizDataTable style={{ marginTop: 15 }} {...dataTableProps} />
            <div className="pagination">
              <WizDataTable.Pagination {...dataTableProps} />
            </div>
          </WizCard>
        </WizCol>

      </WizRow>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { trainPathStage } = state;
  const stageListPage = modelUtils.getModelEntity(trainPathStage, "stageListPage");

  const load = modelUtils.getLoadingState(state, "trainPathStage");
  return {
    stageListPage: stageListPage,
    ...load
  };
};


export default connect(mapStateToProps)(StageList);
